import type { MouseEvent } from 'react';
import { CameraCard } from './CameraCard';
import { gridStyleFor } from './grid-layout';
import type { GridLayout } from '@store/dashboardStore';
import type { Camera } from '@api/types';

interface Props {
  cameras: Camera[];
  layout: GridLayout;
  onToggleFavorite: (camera: Camera) => void;
  onToggleStatus: (camera: Camera) => void;
  onOpenSettings: (camera: Camera) => void;
  onOpenPlayback: (camera: Camera) => void;
  onDelete: (camera: Camera) => void;
  onContextMenu: (camera: Camera, event: MouseEvent<HTMLElement>) => void;
  canManageCameras: boolean;
}

export function CameraGrid({
  cameras,
  layout,
  onToggleFavorite,
  onToggleStatus,
  onOpenSettings,
  onOpenPlayback,
  onDelete,
  onContextMenu,
  canManageCameras,
}: Props): JSX.Element {
  return (
    <div
      className="grid h-full w-full gap-4 overflow-auto px-6 py-6"
      style={gridStyleFor(layout)}
    >
      {cameras.map((camera) => (
        <CameraCard
          key={camera.id}
          camera={camera}
          onToggleFavorite={onToggleFavorite}
          onToggleStatus={onToggleStatus}
          onOpenSettings={onOpenSettings}
          onOpenPlayback={onOpenPlayback}
          onDelete={onDelete}
          onContextMenu={onContextMenu}
          canManageCameras={canManageCameras}
        />
      ))}
    </div>
  );
}
